var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34971"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 268",
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 19.0352L17.5 26.2695L28.5 10",
    stroke: "#0008C3",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.51961af566033e23278e346c8e5f2bc9.svg";
export { ForwardRef as ReactComponent };